import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';
export default function shouldUseMonarchShortcuts(): boolean {
    return isHostAppFeatureEnabled('nativeFriendlyKeyboarding');
}
